import {Link} from "react-router-dom";

const Thanks = () => {
    return (
        <div className="min-h-full pb-12 flex flex-col bg-white">
            <main className="flex-grow flex flex-col justify-center max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center">
                    <p className="text-sm font-semibold text-indigo-600 uppercase tracking-wide">Scoutli.co</p>

                    <h1 className="mt-2 text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">Thanks for reaching out.</h1>

                    <p className="mt-2 text-base text-gray-500">We will contact you as soon as possible.</p>

                    <div className="mt-6">
                        <Link to="/"
                              className="text-base font-medium text-indigo-600 transition-colors hover:text-indigo-500">
                            Go back home<span aria-hidden="true"> &rarr;</span>
                        </Link>
                    </div>
                </div>
            </main>
        </div>
    )
}

export default Thanks;